import styled from 'styled-components';
import { devices } from 'shared/styles/components';

export const PlanFeaturesContainer = styled.div`
  padding: 20px 0;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const PlanFeaturesHeader = styled.div`
  display: grid;
  padding-bottom: 16px;
  grid-auto-columns: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  grid-template-rows: auto;
  border-bottom: 3px solid ${({ theme }) => theme.colors.borderSecondary};

  &.offerings-1 {
    grid-template-columns: 2fr minmax(180px, 180px);

    .offering {
      justify-self: center;
    }
  }

  &.offerings-2 {
    grid-template-columns: 2fr minmax(180px, 180px) minmax(180px, 180px);
  }

  &.offerings-3 {
    grid-template-columns: 2fr minmax(180px, 180px) minmax(180px, 180px) minmax(180px, 180px);
  }

  h2.features {
    margin: 0;
    color: ${({ theme }) => theme.colors.textEmphasis};
    font-size: 24px;
    line-height: 24px;
    font-weight: 700;
    text-align: left;
  }

  .offering {
    position: relative;
    display: block;
    text-align: center;
    grid-column-start: span 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    grid-row-end: span 1;
    white-space: nowrap;

    &.glaci {
      margin-top: 0;
    }

    color: ${({ theme }) => theme.colors.textEmphasis};
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;

    sup {
      color: ${({ theme }) => theme.colors.textTertiary};
      font-size: 16px;
      vertical-align: super;
      line-height: 0;
    }

    &.poweron-pro img {
      width: 120px;
    }
    &.nexum img {
      height: 32px;
    }
    &.glaci img {
      width: 100px;
    }
  }

  @media screen and (max-width: 767px) {
    h2.features {
      font-size: 18px;
    }

    &.offerings-1 {
      grid-template-columns: 2fr 1fr;

      .offering {
        justify-self: center;
      }
    }

    &.offerings-2 {
      grid-template-columns: 2fr 1fr 1fr;
    }

    &.offerings-3 {
      grid-template-columns: 2fr 1fr 1fr 1fr;
    }

    h2,
    .offering {
      font-size: 14px;
    }

    .offering {
      line-height: 20px;
      white-space: nowrap;

      sup {
        font-size: 11px;
      }

      &.poweron-pro img {
        padding: 0 4px;
        width: 100%;
      }
      &.nexum img {
        padding: 0 4px;
        width: 100%;
      }
      &.glaci img {
        padding: 0 4px;
        width: 100%;
      }
    }
  }
`;

export const PlanFeaturesFooter = styled.div`
  display: grid;
  align-items: start;
  padding-top: 24px;
  padding-bottom: 0px;
  min-height: 68px;
  grid-auto-columns: 1fr;
  grid-row-gap: 0px;
  grid-template-rows: auto;

  .offering-button {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 180px;
    width: 100%;

    &.success > a {
      background-color: ${({ theme }) => theme.colors.success};

      &:hover {
        background-color: ${({ theme }) => theme.colors.success};
      }
    }

    &:first-child {
      grid-column-start: 2;
      grid-column-end: 3;
    }
  }

  &.offerings-1 {
    grid-template-columns: 2fr minmax(180px, 180px);

    .offering-button {
      justify-self: center;
    }
  }

  &.offerings-2 {
    grid-template-columns: 2fr minmax(180px, 180px) minmax(180px, 180px);
  }

  &.offerings-3 {
    grid-template-columns: 2fr minmax(180px, 180px) minmax(180px, 180px) minmax(180px, 180px);
  }

  a {
    display: inline-block;
    margin-bottom: auto;
    padding: 7px 12px;
    width: 80%;
    line-height: 24px;
    font-weight: 500;
    text-decoration: none;
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.bgColor};
    border: 0;
    border-radius: 40px;
    cursor: pointer;
    transition-property: background-color, box-shadow;
    transition-duration: 0.2s;

    &.disabled {
      text-decoration: none;
      color: ${({ theme }) => theme.colors.gray300};
      background-color: ${({ theme }) => theme.colors.gray600};
      cursor: not-allowed;
    }

    &:hover:not(.disabled) {
      text-decoration: none;
      background-color: hsl(225, 39%, 56%);
      background-color: hsl(225, 39%, calc(var(--lightness-factor, 1) * 51%));
      box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
    }
  }

  @media ${devices.mobileMax} {
    padding-bottom: 10px;
    grid-column-gap: 10px;
  }

  @media screen and (max-width: 767px) {
    position: relative;
    top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    .offering-button:nth-of-type(n + 2) {
      display: none;
    }
  }
`;
